import { render, staticRenderFns } from "./PromotionHistoryLoading.vue?vue&type=template&id=e2d978ac"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsSkeletonLoader: require('/app/components/Commons/SkeletonLoader.vue').default})
